var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 65,
    height: 65,
    fill: "none",
    viewBox: "0 0 168 168",
    id: "p",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#fff",
    strokeWidth: 2,
    d: "M115.519 53.0232C118.588 57.7263 120.17 63.3159 120.247 69.8125H95.929C95.8104 66.3532 94.4487 63.6191 91.837 61.6639L102.529 41.9616C108.16 44.5819 112.482 48.2691 115.516 53.0191L115.519 53.0232ZM95.9294 70.8125H120.247C120.172 77.1589 118.661 82.6798 115.73 87.3925L92.2151 78.8416C94.5845 76.867 95.819 74.1747 95.9294 70.8125ZM101.617 41.5465L91.0119 61.0879C88.2327 59.2863 84.3974 58.3805 79.5593 58.3162L81.884 37.7514C89.4597 37.7993 96.033 39.0696 101.617 41.5465ZM80.8778 37.75L78.5533 58.3125H72.1873L48.5851 37.75H80.8778ZM47.75 38.3487L71.5 59.04V81.8809L47.75 128.901V38.3487ZM49.3798 127.892L72.3076 82.5H78.8339L101.458 99.3928C95.8686 101.834 89.3033 103.062 81.75 103.062H72H71.5V103.37L49.3798 127.892ZM80.4703 82.4738C85.0234 82.308 88.6364 81.3526 91.261 79.5588L115.174 88.2544C112.134 92.7975 107.914 96.3537 102.497 98.9201L80.4703 82.4738ZM48.3744 130.5L71.5 104.863V130.5H48.3744Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPWhite);
export default __webpack_public_path__ + "static/media/p_white.d14b692e2be18cd43acf5b8791bf556c.svg";
export { ForwardRef as ReactComponent };